export default () => {
    const copyElements = document.querySelectorAll('.copy');

    // Loop through all elements with the class '.copy'
    copyElements.forEach((copyElement) => {
        // Add a click event listener to each element
        copyElement.addEventListener('click', () => {

            event.preventDefault();

            const dataCode = copyElement.getAttribute('data-code');

            const copyContent = document.createElement('textarea');
            copyContent.value = dataCode;
            copyContent.style.position = 'fixed';
            copyContent.style.opacity = 0;
            document.body.appendChild(copyContent);

            copyContent.select();
            document.execCommand('copy');

            document.body.removeChild(copyContent);

            let message = 'Code "' + dataCode + '" copied';

            alert(message);
        });
    });
}